import { Component, OnInit, Input } from '@angular/core';
import { BotonTipo } from '../../../../components/boton/boton';

@Component({
  selector: 'app-ir-tipo-impuesto',
  templateUrl: './ir-tipo-impuesto.component.html',
  styleUrls: ['./ir-tipo-impuesto.component.scss']
})
export class IrTipoImpuestoComponent implements OnInit {
  @Input() type: BotonTipo;
  @Input() tooltipDir: string = 'below';

  constructor() { }

  ngOnInit() {
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
  }
}
